import { Card, Col, Row, Statistic, Typography, Space, Tag } from 'antd';
import { TeamOutlined, FileTextOutlined } from '@ant-design/icons';
import { trpc } from '../../lib/api';

const { Title, Text } = Typography;

export function PartnerDashboardPage() {
  const { data: accessData } = trpc.partnerPortal.listAccessibleCompanies.useQuery({
    status: 'active',
    page: 1,
    limit: 1,
  });

  const { data: requestData } = trpc.partnerPortal.listRequests.useQuery({
    requestStatus: 'pending',
    page: 1,
    limit: 5,
  });

  const pendingRequests = requestData?.requests ?? [];

  return (
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      <Title level={3} style={{ margin: 0 }}>ダッシュボード</Title>

      <Row gutter={16}>
        <Col xs={24} sm={12} lg={8}>
          <Card>
            <Statistic
              title="担当会社数"
              value={accessData?.total || 0}
              prefix={<TeamOutlined />}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <Card>
            <Statistic
              title="未処理申請"
              value={requestData?.total || 0}
              prefix={<FileTextOutlined />}
            />
          </Card>
        </Col>
      </Row>

      <Card title="未処理申請（最新5件）">
        {pendingRequests.length === 0 ? (
          <Text type="secondary">未処理の申請はありません。</Text>
        ) : (
          <Space direction="vertical" size="small" style={{ width: '100%' }}>
            {pendingRequests.map((request) => (
              <div key={request.id} style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  <Text strong>{request.companyName ?? request.companyId}</Text>
                  <div style={{ fontSize: 12, color: '#888' }}>
                    種別: {request.requestType}
                  </div>
                </div>
                <Tag color="orange">承認待ち</Tag>
              </div>
            ))}
          </Space>
        )}
      </Card>
    </Space>
  );
}
